import React from "react";
import Search from "../../../components/searchField";

const HeaderView = ({ onSearch }) => {
    return(
        <div className="row">
            <div className="col-lg-6 col-7">
                <h6 className="text-uppercase text-white text-capitalize ps-3">
                    UNDECIDED REQUESTS
                </h6>
            </div>
            <div className="col-lg-6 col-5 my-auto text-end">
                <Search
                    onSearch={(search_text) => {
                        onSearch(search_text); // pass to parent
                    }}
                />
            </div>
        </div>
    );
}

export default HeaderView;